import React from 'react';
import EasterGame from './EasterGame';

const GameSelector = () => {
  return (
    <EasterGame/>
  );
};

export default GameSelector;
